import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Analytics = () => {
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="h2 mb-2 fw-bold">System Analytics</h1>
          <p className="text-muted mb-0">Overall system performance and metrics</p>
        </div>
      </div>

      <Row className="g-4">
        <Col lg={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Header className="bg-white border-bottom">
              <h5 className="mb-0 fw-semibold">Traffic Overview</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <i className="fas fa-chart-bar fa-3x text-muted mb-3"></i>
                <p className="text-muted">Traffic analytics chart will be displayed here</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Header className="bg-white border-bottom">
              <h5 className="mb-0 fw-semibold">Resource Usage</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <i className="fas fa-server fa-3x text-muted mb-3"></i>
                <p className="text-muted">Resource usage metrics will be displayed here</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Analytics;